import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-bold',
  templateUrl: './wallet-bold.component.html',
  styleUrls: ['./wallet-bold.component.scss']
})
export class WalletBoldComponent {

}
